import React, { useState, useEffect } from 'react';

const VehicleHSDFillingInsideReportAllPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});
  const [vehicleCode, setVehicleCode]=useState([]);
  const [vehicleName,setVehicleName]=useState([]);
  const [vehicleRegNo,setVehicleRegNo]=useState([]);
  const [vehicleType,setVehicleType]=useState([]);

  // Get URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedParams = {
      branch: urlParams.get('branch') || '',
   
      vehicleCode: urlParams.get('vehicleCode') || '',
      vehicleName: urlParams.get('vehicleName') || '',
      vehicleRegNo: urlParams.get('vehicleRegNo') || '',
      from: urlParams.get('from') || '',
      to: urlParams.get('to') || '',
      month: urlParams.get('month') || 'Select',
      year: urlParams.get('year') || 'Select',
     
    };
    setParams(extractedParams);
  }, []);

  console.log("params:", params);

  // Default data structure for fallback
  const defaultReportData = {
    branchName: "HEAD-OFFICE",
    items: [],
    totalRecords: 0
  };

  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      if (!params.branch) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Build API URL with parameters
        const apiParams = new URLSearchParams({
          branch: params.branch,
         
          vehicleCode: params.vehicleCode,
          vehicleName: params.vehicleName,
          vehicleRegNo: params.vehicleRegNo,
          from: params.from,
          to: params.to,
          month: params.month,
          year: params.year,
         
        });

        const apiUrl = `https://www.nissi-india.com/api/hsd_fillingInside?${apiParams.toString()}`;

        const response = await fetch(apiUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        console.log("Fetched Vehicle HSD data:", res);
        
        // Check if API call was successful
        if (!res.success && res.success !== undefined) {
          throw new Error('API returned unsuccessful response');
        }

        // Format date function
        const formatDate = (dateString) => {
          if (!dateString) return '';
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        };

        // Transform API data to match our component structure
        const apiData = res.data || [];
        setVehicleCode(apiData[0].fld_vehicle_code);
        setVehicleName(apiData[0].fld_vehicle_name);
        setVehicleRegNo(apiData[0].fld_vehicle_regno);
        setVehicleType(apiData[0].fld_vehicletypename);
        
        const transformedData = {
          branchName: apiData[0]?.fld_BranchName || "HEAD-OFFICE",
          totalRecords: apiData.length,
          items: apiData.map((item, index) => ({
            sNo: index + 1,
            date: item.fld_Date || item.vehicleCode || "",
            branch: item.fld_BranchName || item.vehicleName || "",

         hsdFillingOpeningHr: item.fld_hsdfillingopeninghr ?? "",
  hsdFillingClosingHr: item.fld_hsdfillingclosinghr ?? "",
  workingHr: item.fld_Workinghr ?? "",
  hsdFillingOpeningKM: item.fld_hsdfillingopeningkm ?? "",
  hsdFillingClosingKM: item.fld_hsdfillingclosingkm ?? "",
  runningKM: item.fld_Workingkm ?? "",
  hsd: item.fld_Qty ?? "",
  dieselConsumptionHr: item.fld_diselconsumptionhr ?? "",
  dieselConsumptionKM: item.fld_diselconsumptionkm ?? "",
           
          })),
        };

        setReportData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching Vehicle HSD report data:', err);
        setError(err.message);
        setReportData(defaultReportData);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [params]);

  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Vehicle HSD report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load Vehicle HSD report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning (if using fallback data) */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Could not fetch data from API ({error}). Showing template.
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center border-b-2 border-black pb-2 mb-4 print:border-black">
          <h2 className="text-lg font-bold underline">VEHICLE HSD FILLING HR/KM REPORT</h2>
        </div>

        {/* Vehicle Info Summary */}
        <div className="grid grid-cols-2 gap-x-8 mb-4 text-sm">
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-32">Vehicle Code</span>
              <span className="mr-2">:</span>
              <span>{vehicleCode || ''}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">Vehicle Reg No</span>
              <span className="mr-2">:</span>
              <span>{vehicleRegNo || ''}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-32">Vehicle Name</span>
              <span className="mr-2">:</span>
              <span>{vehicleName || ''}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-32">Vehicle type</span>
              <span className="mr-2">:</span>
              <span>{vehicleType || ''}</span>
            </div>
          </div>
        </div>

        {/* Vehicle HSD Table */}
        <div className="border-2 border-black mb-4 print:border-black overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-1 py-2 text-center w-12 print:border-black">S.No</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Date</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Branch</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Opening Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Closing Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Working Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Opening KM</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">HSD Filling Closing KM</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Running KM</th>
                <th className="border border-black px-1 py-2 text-center w-16 print:border-black">HSD</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consumption Hr</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Diesel Consumption KM</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.date}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.branch}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.hsdFillingOpeningHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.hsdFillingClosingHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.workingHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.hsdFillingOpeningKM}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.hsdFillingClosingKM}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.runningKM}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.hsd}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.dieselConsumptionHr}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.dieselConsumptionKM}</td>
                </tr>
              ))}

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="12">
                    <div className="text-gray-500">
                      No vehicle HSD records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 8px !important;
          }
          .text-green-600 {
            color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default VehicleHSDFillingInsideReportAllPrint;